import { cva } from "class-variance-authority";

export const SWITCH_STYLES = {
  track:
    "peer inline-flex shrink-0 cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
  trackChecked: "bg-ticketon-lighter-blue",
  trackUnchecked: "bg-ticketon-light-gray",
  thumb: "pointer-events-none block rounded-full bg-white shadow transition-transform",
  container: "flex items-center space-x-2",
} as const;

export const switchVariants = cva(SWITCH_STYLES.track, {
  variants: {
    size: {
      sm: "h-4 w-7 p-0.5",
      default: "h-5 w-9 p-0.5",
      lg: "h-6 w-11 p-0.5",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export type SwitchSize = "sm" | "default" | "lg";

export const THUMB_SIZE_CLASSES: Record<SwitchSize, string> = {
  sm: "h-3 w-3",
  default: "h-4 w-4",
  lg: "h-5 w-5",
};

export const THUMB_TRANSLATE_CLASSES: Record<SwitchSize, string> = {
  sm: "translate-x-3",
  default: "translate-x-4",
  lg: "translate-x-5",
};
